import {
  PEOPLE_RANKING_GET,
  CLOSED_ORDERS_FILTER_ASC,
  CLOSED_ORDERS_FILTER_DESC
} from "./mutation-types";
export default {
  [PEOPLE_RANKING_GET](state, data) {
    if (!data.branch) data.branch = "global";
    state.people[data.branch] = [];
    data.peopleData.forEach(person => {
      state.people[data.branch].push({
        id: person.id,
        name: person.data().name,
        photo_url: person.data().photoURL
          ? "data:image/png;base64, " + person.data().photoURL
          : "https://firebasestorage.googleapis.com/v0/b/prosic-dev.appspot.com/o/dynamic-board%2FemptyPhotoURL.png?alt=media&token=997617c2-ecee-4645-9ead-6476e478ead0",
        venue: person.data().venue,
        assigned_orders: person.data().assignedOrders
          ? person.data().assignedOrders
          : 0,
        closed_orders: person.data().closedOrders
          ? person.data().closedOrders
          : 0,
        open_orders: person.data().openOrders ? person.data().openOrders : 0,
        time: person.data().duration ? person.data().duration : 0
      });
    });
    state.people[data.branch].sort(function(a, b) {
      if (a.closed_orders < b.closed_orders) {
        return 1;
      }
      if (a.closed_orders > b.closed_orders) {
        return -1;
      }
      return 0;
    });
    state.peopleUpdated = new Date();
  },
  [CLOSED_ORDERS_FILTER_ASC](state) {
    state.people.sort(function(a, b) {
      if (a.closed_orders > b.closed_orders) {
        return 1;
      }
      if (a.closed_orders < b.closed_orders) {
        return -1;
      }
      return 0;
    });
  },
  [CLOSED_ORDERS_FILTER_DESC](state) {
    state.people.sort(function(a, b) {
      if (a.closed_orders < b.closed_orders) {
        return 1;
      }
      if (a.closed_orders > b.closed_orders) {
        return -1;
      }
      return 0;
    });
  }
};
